import { Reveal, SectionHeader } from "./shared";
import { intro } from "../../data/portfolioData";

export const IntroStats = () => (
  <section id="intro" className="py-20 lg:py-28" data-testid="intro-stats-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-start">
        <div>
          <SectionHeader index="01" eyebrow="The Mission" title={intro.heading} testId="intro-header" />
          {intro.body.map((p, i) => (
            <Reveal key={i} delay={0.1 + i * 0.08}>
              <p className="text-sm sm:text-base text-slate-400 leading-relaxed mb-5">{p}</p>
            </Reveal>
          ))}
          <Reveal delay={0.3}>
            <p className="font-code text-xs uppercase tracking-[0.25em] text-slate-500 mt-8">
              Full-Stack <span className="text-amber-400">×</span> Mobile Apps <span className="text-amber-400">×</span> Backend
            </p>
          </Reveal>
          <Reveal delay={0.38}>
            <div className="mt-6 rounded-2xl border border-white/[0.07] bg-[#0A0E17] overflow-hidden" data-testid="intro-terminal">
              <div className="flex items-center gap-1.5 border-b border-white/[0.06] px-4 py-2.5">
                <span className="h-2.5 w-2.5 rounded-full bg-red-400/70" />
                <span className="h-2.5 w-2.5 rounded-full bg-amber-400/70" />
                <span className="h-2.5 w-2.5 rounded-full bg-emerald-400/70" />
                <span className="ml-2 font-code text-[10px] text-slate-500">terminal</span>
              </div>
              <div className="p-4 font-code text-xs leading-6">
                <p><span className="text-emerald-400">vishal@dev</span><span className="text-slate-500">:~$</span> <span className="text-slate-200">whoami</span></p>
                <p className="text-slate-400">full-stack & app developer — web · mobile · backend</p>
                <p><span className="text-emerald-400">vishal@dev</span><span className="text-slate-500">:~$</span> <span className="text-slate-200">status --now</span></p>
                <p className="text-slate-400">shipping production apps & systems <span className="text-amber-400 animate-pulse">▊</span></p>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="grid grid-cols-2 gap-4 sm:gap-5 lg:mt-24">
          {intro.stats.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.1}>
              <div
                className="group rounded-2xl border border-white/[0.07] bg-[#0F1420] p-6 transition-all duration-500 hover:border-amber-400/25 hover:bg-[#141B2C] hover:shadow-[0_0_40px_-14px_rgba(245,158,11,0.35)]"
                data-testid={`stat-card-${i}`}
              >
                <p className="font-display text-3xl sm:text-4xl font-bold text-slate-50 group-hover:text-amber-300 transition-colors duration-500">
                  {s.value}
                </p>
                <p className="mt-2 text-sm font-medium text-slate-300">{s.label}</p>
                <p className="mt-1 text-xs text-slate-500">{s.note}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
